import { faCheck } from "@jewlr/pro-solid-svg-icons/faCheck"
import {
  Checkbox as CheckboxPrimitive,
  Indicator,
} from "@radix-ui/react-checkbox"
import { Label } from "@radix-ui/react-label"
import PropTypes from "prop-types"
import { forwardRef, memo } from "react"

import { cn } from "styles/utils"

import FontAwesomeIcon from "./font-awesome-icon"

const Checkbox = forwardRef(
  (
    { checkboxClassName, checked, children, className, onChange, ...props },
    ref
  ) => (
    <Label
      className={cn(
        "text-14 focus-within:outline-primary inline-flex cursor-pointer items-center gap-4 align-middle text-black focus-within:outline-2 focus-within:outline-offset-2",
        className
      )}
      data-slot="label"
    >
      <CheckboxPrimitive
        checked={checked}
        className={cn(
          "rounded-xs disabled:bg-grey-10 outline-hidden size-16 shrink-0 border border-current bg-white disabled:cursor-not-allowed disabled:opacity-50",
          checkboxClassName
        )}
        data-slot="checkbox"
        ref={ref}
        {...props}
        onCheckedChange={onChange}
      >
        <Indicator
          className="flex items-center justify-center text-current"
          data-slot="checkbox-indicator"
        >
          <FontAwesomeIcon className="size-12 align-middle" icon={faCheck} />
        </Indicator>
      </CheckboxPrimitive>
      {children}
    </Label>
  )
)

Checkbox.propTypes = {
  checkboxClassName: PropTypes.string,
  checked: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  onChange: PropTypes.func,
}

Checkbox.displayName = "Checkbox"

export default memo(Checkbox)
